import {
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  useMutation,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { ApiErrorResponse, ApiResponse } from '../../../constant/api';
import { api } from '../../../utils/api';

interface GetDownloadLinkRequest {
  hash: string;
  isBulk?: boolean;
}

interface GetDownloadLinkResponse {
  url: string;
}

const getDownloadLink = ({ hash, isBulk = false }: GetDownloadLinkRequest) => {
  return api.get('/v2/viewer/download', {
    params: {
      hash,
      isBulk,
    },
  });
};

const useFileDownloadLink = <TError = AxiosError<ApiErrorResponse>>(
  options?: UseMutationOptions<
    AxiosResponse<ApiResponse<GetDownloadLinkResponse>>,
    TError,
    GetDownloadLinkRequest,
    QueryKey
  >,
): UseMutationResult<
  AxiosResponse<ApiResponse>,
  TError,
  GetDownloadLinkRequest,
  QueryKey
> => {
  return useMutation(getDownloadLink, { ...options });
};

export default useFileDownloadLink;
